import cRequest from "@services/c-request"

const ordersPath = `${process.env.REACT_APP_BASE_URL}/orders`

interface GetOrdersServiceProps {
  uid?: string
  tenantid?: string
  start?: number
  qty?: number
}
interface GetOrderServiceProps {
  orderid: string
  live: boolean
}

interface getAllOrdersServiceProps {
  tenantid: string
  startDate: string
  endDate: string
}

export const getOrderService = async ({
  orderid,
  live,
}: GetOrderServiceProps) => {
  if (!orderid) return {}

  return cRequest
    .get(`${ordersPath}/get-order`, { params: { orderid, live } })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const getOrdersService = async ({
  uid,
  tenantid,
  start,
  qty,
}: GetOrdersServiceProps) => {
  if (!uid && !tenantid) return []

  return cRequest
    .get(`${ordersPath}/get-orders`, { params: { uid, tenantid, start, qty } })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const getAllOrdersService = async ({
  tenantid,
  startDate,
  endDate,
}: getAllOrdersServiceProps) => {
  return cRequest
    .get(`${ordersPath}/get-all-orders`, {
      params: { tenantid, startDate, endDate },
    })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const getOrdersProcessingService = async (uid: any) => {
  if (!uid) return []

  return cRequest
    .get(`${ordersPath}/get-orders-processing`, { params: { uid } })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const updateOrderService = async (body: {
  orderid: string
  status?: any[]
  test?: boolean
}) => {
  return cRequest
    .put(`${ordersPath}/update-order`, body)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const archiveOrderService = async (body: any) => {
  return cRequest
    .post(`${ordersPath}/archive-order`, body)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const getArchivedOrdersService = async (uid: string) => {
  if (!uid) return []

  return cRequest
    .get(`${ordersPath}/get-archived-orders`, { params: { uid } })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}
